import React from 'react';

import { Container, WrapperFullHeight } from './styles';
import FooterWrapper from '../../../../components/FooterWrapper';
import { Button } from '../../../../components';
import { usePlatformContext } from '../../../../contexts/PlatformContext';
import { Conclusion } from '../../../../components/Icons/Conclusion';

type AppointmentConclusionProps = {
  token: string;
};

export const AppointmentConclusion = ({ token }: AppointmentConclusionProps) => {
  const { setIsSchedulerOpen, clearData } = usePlatformContext();

  return (
    <Container>
      <WrapperFullHeight>
        <Conclusion />
        <h1 className="title">Agendamento realizado com sucesso!</h1>
        {token ? (
          <>
            <p className="subtitle">Para consultar as informações do seu agendamento use o código:</p>
            <p className="code">{token}</p>
          </>
        ) : (
          <>
            <p className={'subtitle'}>Enviamos as informações do agendamento para o seu e-mail</p>
          </>
        )}
      </WrapperFullHeight>
      <FooterWrapper>
        <Button
          title="Ir para home"
          onClick={() => {
            clearData();
            setIsSchedulerOpen(false);
          }}
        />
      </FooterWrapper>
    </Container>
  );
};
